export default __webpack_public_path__ + "static/media/logo-sobatpajak-light.3714d498.svg";